import React from 'react';
import RulesWrapper from './RulesWrapper';
import {TableLayout} from '../../../../../components';
import {viewRules} from '../../../../../assets/images/images';

function BehaviouralMonitoring() {
  const rows = [
    {
      category: 'Low-Value Transaction Frequency',
      rulesCount: 13,
      score: 5,
    },
    {
      category: 'High-Frequency Transactions',
      rulesCount: 4,
      score: 6,
    },
    {
      category: 'Daily Transaction Limit',
      rulesCount: 10,
      score: 33,
    },
  ];

  return (
    <RulesWrapper>
      <TableLayout className="mt-5  ">
        <thead className="text-xs font-semibold uppercase">
          <tr className="bg-[#F9FAFB] border-b border-[#E1E4EA]">
            <th className="py-3 px-6 text-left text-small font-medium text-[#4F555F]">
              Category
            </th>{' '}
            <th className="py-3 px-6 text-left text-small font-medium text-[#4F555F]">
              Rules
            </th>{' '}
            <th className="py-3 px-6 text-left text-small font-medium text-[#4F555F]">
              Score
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={index}
              className="border-b cursor-pointer border-[#E1E4EA] h-[72px] text-tiny text-[#4F555F]"
            >
              <td className="pl-6">{row.category}</td>
              <td className="pl-6">
                <div className="flex items-center gap-3">
                  <p className="text-black">
                    <span>{row.rulesCount}</span> Rules
                  </p>
                  <div className="flex items-center gap-2 py-1 px-2 bg-[#F2F6FE] rounded-full">
                    <p className="text-small text-[#1E2254] font-medium">
                      View rules
                    </p>
                    <img src={viewRules} alt="view" />
                  </div>
                </div>
              </td>
              <td className="pl-6">{row.score}</td>
            </tr>
          ))}
        </tbody>
      </TableLayout>
    </RulesWrapper>
  );
}

export default BehaviouralMonitoring;
